import { parseDate } from '@shiftbase-com/ts-shared/utilities';
import { getISOWeek, getISOWeekYear } from 'date-fns';
import groupBy from 'lodash-es/groupBy';

// The ISO week year is part of the key because early January and late December
// can fall in a neighbouring year's week, where the week number alone collides.
export function groupDayStatsPerWeek<TDayStat extends { date: string }>(
  dayStats: { day_stats: TDayStat[] } | null,
): Record<string, TDayStat[]> | null {
  if (!dayStats) {
    return dayStats;
  }

  return groupBy(dayStats.day_stats, (dayStat) => {
    const date = parseDate(dayStat.date);

    return `${getISOWeekYear(date)}${String(getISOWeek(date)).padStart(2, '0')}`;
  });
}
